import React, { useMemo } from "react";
import GenericModal from "../../Ui/Modal";
import Section from "../common/Details";
import ButtonComponent from "../../Ui/Button";
import { MODAL_STATES } from "../../constant/Home/Jobs";

const enhancePropertySection = (sections, propertyLabel, unitLabel) => {
  return sections.map((section) => {
    if (section.title !== "Step 3 – Property") return section;
    return {
      ...section,
      items: section.items.map((item) => {
        if (item.label === "Property:") {
          return { ...item, value: propertyLabel || item.value };
        }
        if (item.label === "Unit:") {
          return { ...item, value: unitLabel || item.value };
        }
        return item;
      }),
    };
  });
};

const JobSummaryModal = ({
  open,
  onClose,
  sections = [],
  mode = MODAL_STATES.JOB_SUMMARY,
  onViewBackend,
  onContinue,
}) => {
  const propertySectionValues = useMemo(() => {
    const target = sections.find((section) => section.title === "Step 3 – Property");
    if (!target) return {};
    const getValue = (label) =>
      target.items.find((item) => item.label === label)?.value || "";
    return {
      propertyLabel: getValue("Property:"),
      unitLabel: getValue("Unit:"),
    };
  }, [sections]);

  const contentSections = useMemo(
    () => enhancePropertySection(sections, propertySectionValues.propertyLabel, propertySectionValues.unitLabel),
    [sections, propertySectionValues]
  );

  const content = (
    <Section
      sections={contentSections}
      className="max-h-[70vh] overflow-y-auto pr-2"
    />
  );

  const title =
    mode === MODAL_STATES.JOB_SUMMARY
      ? "Review Your Submission"
      : "Job Details";

  const footer = (
    <div className="flex w-full justify-between gap-2 flex-wrap">
      <div className="flex gap-2 ml-auto">
        <ButtonComponent onClick={onClose}>Close</ButtonComponent>
      </div>
    </div>
  );

  return (
    <GenericModal
      open={open}
      onClose={onClose}
      title={title}
      children={content}
      footer={footer}
      maxWidth="953px"
    />
  );
};

export default JobSummaryModal;
